import React, { useEffect, useState } from "react";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import Location from "./Location";
import SocialMedia from "./SocialMedia";
import "../general/General.css";



const ContactUs = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <Navbar />
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs />
            <br />
            <p><b>தர்மகர்த்தா பெயர்:</b> திரு.எஸ் சிவராஜ்</p>
            <p><b>தொலைபேசி எண்:</b> 📞 9943475494</p>
          </div>
        </div>
      </div>
      <br />
      <SocialMedia windowWidth={windowWidth} />
      <Location windowWidth={windowWidth} />
      <Footer />
    </>
  );
};

export default ContactUs;
